document.addEventListener("DOMContentLoaded", load_event=>{
 document.querySelectorAll('form.delete_comment').forEach(elem=>{elem.addEventListener("submit", e=>{
  e.preventDefault();
  let lang_de=document.documentElement.lang=='de';
  UhhDialog.showModal((lang_de ? 'Kommentar löschen' : 'Delete comment'), (lang_de ? 'Sind Sie sicher, dass Sie diesen Kommentar (und ggf. daran anhängende Kommentare) löschen möchten?' : 'Are you sure you want to delete this comment?'),[[(lang_de ? 'Abbrechen' : 'Cancel'), ()=>{UhhDialog.closeTopmostDialog()}], [(lang_de ? 'Löschen' : 'Delete'), ()=>{elem.submit()}]], 1);
 })})

});
